import { render, staticRenderFns } from "./ReceiptHistory.vue?vue&type=template&id=25227c6c&scoped=true"
import script from "./ReceiptHistory.vue?vue&type=script&lang=js"
export * from "./ReceiptHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25227c6c",
  null
  
)

export default component.exports